import { FileUploadAPI } from "../api/FileUpload.api";
export class FileUpload {
  constructor(props) { }
  static async upload(fileData, fileLastName = '', isBase64 = false) {
    if (!isBase64) {
      const splitFileData = fileData.name.split(".");
      fileLastName = splitFileData[splitFileData.length - 1] || splitFileData[0]
    }
    const { data } = await FileUploadAPI.upload(fileData, fileLastName, isBase64);
    return data;
  }
  static async uploads(filesData) {
    let uploads = []
    for (let file of filesData) {
      uploads.push(FileUploadAPI.upload(file))
    }
    let callBacks = await Promise.all(uploads)
    return callBacks.map(d => d.data)
  }
  static urlToFile(url, filename, type){
    return (fetch(url)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], filename, { type: type });})
    );
  }
}
